import i18n from 'i18next';

export const formatDate = (utcDateString: string) => {
  const utcDate = new Date(utcDateString);
  const locale = i18n.language || 'en';
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(locale, {
    timeZone
  }).format(utcDate);
};
